import { useCallback, useState } from 'react'

export function useDialogState(
  initialState: boolean = false,
): [state: boolean, onOpen: () => void, onClose: () => void] {
  const [open, setOpen] = useState(initialState)
  const onOpen = useCallback(() => void setOpen(true), [])
  const onClose = useCallback(() => void setOpen(false), [])

  return [open, onOpen, onClose]
}
